const storeEventConst = {
  EVENT_SET_CURRENT_ROUTE: 'setCurrentRoute',
};

export default storeEventConst;
